import { styled } from "@mui/material/styles";
import {
  Grid,
  Box,
  IconButton as MuiIconButton,
  AppBar as MuiAppBar,
  Paper,
  TextField,
  Alert,
  Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PlaceholdersContainer = styled(Grid)({
  height: "100%",
  display: "flex",
  flexFlow: "column",
  justifyContent: "space-between",
});

export const Placeholder = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "height",
})(
  ({ theme }) => ({
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "15px",
    padding: "10px",
    color: theme.palette.primary.contrastText,
  }),
  ({ height }) => ({
    ...(height && { height: `${height}px` }),
  })
);

export const Form = styled(Box)({
  width: "100%",
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  gap: "15px",
  marginTop: "30px",
});

export const StyledTextfield = styled(TextField)(({ theme }) => ({
  width: "30%",
}));

export const UtilsContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
});

export const Container = styled(Grid)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
}));

export const HeaderContainer = styled(Grid)(({ theme }) => ({
  height: 80,
}));

export const Header = styled(MuiAppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  display: "flex",
  height: 80,
  flexDirection: "row",
  alignItems: "center",
  padding: "0 30px",
  width: "100%",

  "& a": {
    transition: "all 0.25s linear",
    padding: "4px",
    width: "fit-content",
    borderRadius: "5px",
    boxShadow: `0px 5px 20px -2px ${theme.palette.primary.dark}`,
    border: "0.5px white solid",
  },
}));

export const DocumentContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  display: "flex",
  padding: "35px",
  flexDirection: "column",
}));

export const DocumentTitleContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  padding: "20px 0",
  flexWrap: "wrap",
}));

export const DocumentInfoContainer = styled(Paper)(({ theme }) => ({
  marginTop: "15px",
  width: "100%",
  padding: " 0 20px",
  boxSizing: "border-box",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  margin: "5px 0px",
}));

export const DocumentDetailsContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  // display: "flex",
  // justifyContent : "space-between",
  paddingBottom: "20px",
  flexWrap: "wrap",
}));

export const FilesContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  // justifyContent : "space-between",
  marginTop: "20px",
  display: "flex",
  gap: "15px",
  flexWrap: "wrap",
}));

export const FileContainer = styled(Paper)(({ theme }) => ({
  // width : "fit-content",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  padding: "20px",
}));

export const IconButton = styled(MuiIconButton)({
  width: "fit-content",

  "& > svg": {
    width: "40px",
  },
});

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
}));

export const StyledAlertError = styled(Alert)({
  margin: "40px auto",
  width: "fit-content",
});

export const StyledAlertInfo = styled(Alert)({
  width: "fit-content",
});

export const LoginButton = styled("div")(({ theme }) => ({
  marginLeft: "auto",

  "& a": {
    padding: "7px",
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.contrastText,
    textDecoration: "none",
    gap: "5px",
  },
}));

export const HomeButton = styled("div")(({ theme }) => ({
  "& a": {
    padding: "7px",
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.contrastText,
    textDecoration: "none",
    gap: "5px",
  },
}));
